/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-20 09:42:49
 */
import React, { useEffect, FC, useState } from "react";
import { connect } from "react-redux";
import { Avatar, message } from "antd";
import { useHistory } from "react-router-dom";
import "./index.less";
import { RightCircleOutlined } from "@ant-design/icons";
import axios from "@/axios/axios";
const Expert: FC<any> = () => {
  const history = useHistory();
  // 教师列表
  const [teacherList, setTeacherList] = useState([] as any);
  const getTeacher = async () => {
    const { code, data, msg }: any = await axios.post(
      "/shop/front/ce/teacher/list",
      { page: { currentPage: 1, pageSize: 8 } }
    );
    if (code === 0) {
      setTeacherList(data.itemTeacherList || []);
    } else {
      message.error(msg);
    }
  };

  useEffect(() => {
    getTeacher();
  }, []);

  return (
    <div className={"expert-module"}>
      <div className={"home-title-bar"}>
        <span className={"title"}>专家风采</span>
        <span
          className={"more"}
          onClick={() => {
            history.push("/index/expertDemeanorList");
          }}
        >
          更多
          <span>
            <RightCircleOutlined
              style={{ fontSize: "16px", marginLeft: "8px" }}
            />
          </span>
        </span>
      </div>
      <div className={"expert-list"}>
        <ul>
          {teacherList.map((item: any, i: number) => (
            <li
              key={i}
              onClick={() => {
                history.push(`/index/demeanorInfo?id=${item.id}`);
              }}
            >
              <Avatar size={99} src={item.imageAllPath} />
              <p>{item.name}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default connect((state) => state)(Expert);
